export default __webpack_public_path__ + "assets/img/paraphrase.fa3a11dd37bdc58c6eef85a2105b2302.png";